"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var calendarLabel = 'Calendar';
var enterKey = 'Enter key';
var escape = 'Escape key';
var hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
var homeEnd = 'Home and end keys';
var jumpToPrevMonth = 'Move backward to switch to the previous month.';
var jumpToNextMonth = 'Move forward to switch to the next month.';
var keyboardShortcuts = 'Keyboard Shortcuts';
var leftArrowRightArrow = 'Right and left arrow keys';
var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day.';
var moveFocusByOneMonth = 'Switch months.';
var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week.';
var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week.';
var openThisPanel = 'Open this panel.';
var pageUpPageDown = 'page up and page down keys';
var questionMark = 'Question mark';
var returnFocusToInput = 'Return to the date input field.';
var selectFocusedDate = 'Select the date in focus.';
var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel.';
var upArrowDownArrow = 'up and down arrow keys';
var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
  var date = _ref.date;
  return "Choose ".concat(date, ". It\u2019s available.");
};
var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
  var date = _ref2.date;
  return "Choose ".concat(date, ". It\u2019s available.");
};
var chooseAvailableDate = function chooseAvailableDate(_ref3) {
  var date = _ref3.date;
  return date;
};
var dateIsUnavailable = function dateIsUnavailable(_ref4) {
  var date = _ref4.date;
  return "Not available. ".concat(date);
};
var dateIsSelected = function dateIsSelected(_ref5) {
  var date = _ref5.date;
  return "Selected. ".concat(date);
};
var _default = {
  calendarLabel: calendarLabel,
  chooseAvailableDate: chooseAvailableDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  chooseAvailableStartDate: chooseAvailableStartDate,
  dateIsSelected: dateIsSelected,
  dateIsUnavailable: dateIsUnavailable,
  enterKey: enterKey,
  escape: escape,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  homeEnd: homeEnd,
  jumpToNextMonth: jumpToNextMonth,
  jumpToPrevMonth: jumpToPrevMonth,
  keyboardShortcuts: keyboardShortcuts,
  leftArrowRightArrow: leftArrowRightArrow,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  openThisPanel: openThisPanel,
  pageUpPageDown: pageUpPageDown,
  questionMark: questionMark,
  returnFocusToInput: returnFocusToInput,
  selectFocusedDate: selectFocusedDate,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  upArrowDownArrow: upArrowDownArrow
};
exports["default"] = _default;